window.TrackingSDK = (function () {

  function getCurrency() {
    return (window.__TRACKING__ && window.__TRACKING__.page && window.__TRACKING__.page.currency) || 'EUR';
  }

  // =============================
  // UTILS
  // =============================
  function cents(n) { return (n || 0) / 100; }

  function sha256(str) {
    if (!str || !window.crypto || !window.crypto.subtle) return Promise.resolve('');
    var buf = new TextEncoder().encode(str);
    return window.crypto.subtle.digest('SHA-256', buf).then(function (hash) {
      return Array.from(new Uint8Array(hash))
        .map(function (b) { return b.toString(16).padStart(2, '0'); })
        .join('');
    });
  }

  function getDeviceType() {
    var ua = navigator.userAgent;
    if (/tablet|ipad/i.test(ua)) return 't';
    if (/mobile|android|iphone|ipod/i.test(ua)) return 'm';
    return 'd';
  }

  function mapPageType(pt) {
    var map = {
      'index':             'homepage',
      'collection':        'category listing',
      'product':           'product',
      'cart':              'cart',
      '404':               '404',
      'search':            'search results',
      'search_no_results': 'no results page'
    };
    if (map[pt] !== undefined) return map[pt];
    if (pt && pt.indexOf('customers') === 0) return 'account';
    return 'other';
  }

  // =============================
  // ATTRIBUTION STORE
  // =============================
  var Attribution = (function () {
    var KEY = '_tracking_attr';

    function load() {
      try { return JSON.parse(sessionStorage.getItem(KEY)) || {}; }
      catch (e) { return {}; }
    }

    function save(data) {
      try { sessionStorage.setItem(KEY, JSON.stringify(data)); }
      catch (e) {}
    }

    return {
      set: function (id, ctx) {
        var d = load();
        d[String(id)] = ctx;
        save(d);
      },
      get: function (id) {
        var d = load();
        return d.hasOwnProperty(String(id)) ? d[String(id)] : null;
      }
    };
  })();

  // =============================
  // BUILD ITEM  (view_item, view_item_list, select_item)
  // Accepts a flat data object:
  // { id, variant_id, title, category, category2,
  //   price (cents), compare_at_price (cents),
  //   available, inventory_quantity }
  // qty  : integer quantity
  // ctx  : optional { item_list_name, index } — overrides attribution store
  // =============================
  function buildItem(data, qty, ctx) {
    var attrCtx = ctx || Attribution.get(data.variant_id || data.id) || {};
    var price   = cents(data.price || 0);
    var cmp     = cents(data.compare_at_price || 0);

    var item = {
      item_id:           String(data.id),
      item_name:         (data.title?.split('-')[0]?.trim() || ''),
      item_color:        (data.title?.split('-')[1]?.trim() || ''),
      item_category:     data.category      || '',
      item_category2:    data.category2     || '',
      item_availability: (function () {
                           if (data.variants && data.variants.length) {
                             var v = data.variant_id
                               ? (data.variants.find(function (v) { return v.id == data.variant_id; }) || data.variants[0])
                               : data.variants[0];
                             return v.available ? 'in stock' : 'out of stock';
                           }
                           return data.available ? 'in stock' : 'out of stock';
                         })(),
      item_sku:          data.sku            || '',
      stock_quantity:    data.variants
                           ? data.variants.reduce(function (s, v) { return s + (v.inventory_quantity || 0); }, 0)
                           : (data.inventory_quantity || 0),
      item_variant_id:   data.variant_id != null ? String(data.variant_id) : null,
      item_isdiscounted: (cmp > 0 && cmp > price) ? 'yes' : 'no',
      currency:          getCurrency(),
      price:             price,
      discount:          0,
      quantity:          qty || 1
    };

    if (attrCtx.item_list_name !== undefined) item.item_list_name = attrCtx.item_list_name;
    if (attrCtx.index          !== undefined) item.index          = attrCtx.index;

    return item;
  }

  // =============================
  // BUILD CART ITEM  (from /cart.js item)
  // =============================
  function buildCartItem(cartItem, qty) {
    var ctx   = Attribution.get(String(cartItem.variant_id)) ||
                Attribution.get(String(cartItem.product_id)) || {};
    var price = cents(cartItem.price || 0);
    var cmp   = cents(cartItem.compare_at_price || 0);

    var item = {
      item_id:           String(cartItem.product_id),
      item_name:         (cartItem.product_title?.split('-')[0]?.trim() || cartItem.title?.split('-')[0]?.trim() || ''),
      item_sku:          cartItem.sku              || '',
      item_category:     ctx.category              || cartItem.product_type || '',
      item_category2:    ctx.category2             || '',
      item_variant:      cartItem.variant_title    || '',
      item_color:       (ctx.color || ''),
      item_availability: cartItem.available !== undefined ? (cartItem.available ? 'in stock' : 'out of stock') : 'in stock',
      stock_quantity:    (function () {
                           var vs = Attribution.get('vstock:' + cartItem.variant_id);
                           if (vs !== null) return vs;
                           if (cartItem.inventory_quantity !== undefined) return cartItem.inventory_quantity;
                           return ctx.stock_quantity || 0;
                         })(),
      item_variant_id:   String(cartItem.variant_id),
      item_isdiscounted: (cmp > 0 && cmp > price) ? 'yes' : 'no',
      currency:          getCurrency(),
      price:             price,
      discount:          0,
      quantity:          qty || cartItem.quantity || 1
    };

    if (ctx.item_list_name !== undefined) item.item_list_name = ctx.item_list_name;
    if (ctx.index          !== undefined) item.index          = ctx.index;

    return item;
  }

  // =============================
  // PUBLISH
  // =============================
  function publish(name, payload) {
    if (window.Shopify && Shopify.analytics) {
      Shopify.analytics.publish(name, payload);
    }
  }

  // =============================
  // TRACK API
  // =============================
  var track = {

    pageview: function (pageCtx, userCtx) {
      userCtx = userCtx || {};
      var email = userCtx.email || '';

      return sha256(email).then(function (hash) {
        publish('pageview', {
          event: 'pageview',
          page: {
            page_status_code: '200',
            page_type:        mapPageType(pageCtx.page_type || ''),
            page_country:     pageCtx.page_country  || '',
            page_language:    pageCtx.page_language || '',
            device_type:      getDeviceType()
          },
          user: {
            user_status: userCtx.user_status || 'guest',
            emailSHA256: hash,
            user_id:     String(userCtx.user_id || '')
          }
        });
      });
    },

    viewItem: function (data) {
      var _existing = Attribution.get(String(data.variant_id || data.id)) || {};
      var _enrich = {
        category:       data.category          || '',
        category2:      data.category2         || '',
        color:         data.color            || '',
        stock_quantity: data.inventory_quantity || 0
      };
      if (_existing.item_list_name !== undefined) _enrich.item_list_name = _existing.item_list_name;
      if (_existing.index          !== undefined) _enrich.index          = _existing.index;
      Attribution.set(String(data.variant_id || data.id), _enrich);
      if (data.variant_id) Attribution.set(String(data.id), _enrich);
      if (data.variants) {
        data.variants.forEach(function (v) {
          Attribution.set('vstock:' + v.id, v.inventory_quantity || 0);
        });
      }
      var _item = buildItem(data, 1);
      publish('view_item', {
        event: 'view_item',
        ecommerce: {
          currency: getCurrency(),
          value:    _item.price,
          items:    [_item]
        }
      });
    },

    viewItemList: function (products, listName) {
      var items = products.map(function (p, i) {
        var ctx = {
          item_list_name: listName,
          index:          i,
          category:       p.category          || '',
          category2:      p.category2         || '',
          color:         p.color            || '',
          stock_quantity: p.inventory_quantity || 0
        };
        Attribution.set(String(p.variant_id || p.id), ctx);
        Attribution.set(String(p.id), ctx);
        return buildItem(p, 1, ctx);
      });
      publish('view_item_list', {
        event: 'view_item_list',
        ecommerce: { items: items }
      });
    },

    selectItem: function (data, listName, index) {
      var ctx = {
        item_list_name: listName,
        index:          index,
        category:       data.category          || '',
        category2:      data.category2         || '',
        color:         data.color            || '',
        stock_quantity: data.inventory_quantity || 0
      };
      Attribution.set(String(data.variant_id || data.id), ctx);
      if (data.variant_id) Attribution.set(String(data.id), ctx);
      publish('select_item', {
        event: 'select_item',
        ecommerce: { items: [buildItem(data, 1, ctx)] }
      });
    },

    addToCart: function (cartItem, qty) {
      var item = buildCartItem(cartItem, qty);
      publish('add_to_cart', {
        event: 'add_to_cart',
        ecommerce: {
          page_currency: getCurrency(),
          value:         item.price * qty,
          items:         [item]
        }
      });
    },

    removeFromCart: function (cartItem, qty) {
      var item = buildCartItem(cartItem, qty);
      publish('remove_from_cart', {
        event: 'remove_from_cart',
        ecommerce: {
          page_currency: getCurrency(),
          value:         item.price * qty,
          items:         [item]
        }
      });
    },

    viewCart: function (cart) {
      var items = cart.items.map(function (i) {
        return buildCartItem(i, i.quantity);
      });
      publish('view_cart', {
        event: 'view_cart',
        ecommerce: {
          page_currency: getCurrency(),
          value:         cents(cart.total_price),
          items:         items
        }
      });
    },

    viewPromotion: function (promo) {
      publish('view_promotion', {
        event: 'view_promotion',
        ecommerce: {
          creative_name:  promo.creative_name  || '',
          creative_slot:  promo.creative_slot  || '',
          promotion_id:   promo.promotion_id   || '',
          promotion_name: promo.promotion_name || ''
        }
      });
    },

    selectPromotion: function (promo) {
      publish('select_promotion', {
        event: 'select_promotion',
        ecommerce: {
          creative_name:  promo.creative_name  || '',
          creative_slot:  promo.creative_slot  || '',
          promotion_id:   promo.promotion_id   || '',
          promotion_name: promo.promotion_name || ''
        }
      });
    }
  };

  return { track: track, buildItem: buildItem, Attribution: Attribution };

})();
